import React, {useEffect,useRef} from 'react'
import ReactToPrint from 'react-to-print';

import Timetable from 'react-timetable-events'
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Close from '@mui/icons-material/Close';

import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import axios from 'axios';


import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { seedetails, getproducts } from './redux/todoSlice';
import { admin } from './redux/admin';
import { schooldetails } from './redux/schooldetails';
import { loin, logout, updateschooldata, getdata_ } from './redux/class';
import { Divider } from '@mui/material';

/** react-timetable-events expects each event's startTime/endTime as values date-fns can format. */
const EMPTY_TIMETABLE_DAYS = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
};

function mergeEmptyDays(raw) {
  if (!raw || typeof raw !== 'object') return { ...EMPTY_TIMETABLE_DAYS };
  return { ...EMPTY_TIMETABLE_DAYS, ...raw };
}

function toValidDate(v) {
  if (v == null || v === '') return null;
  if (v instanceof Date && !Number.isNaN(v.getTime())) return v;
  const n = typeof v === 'number' ? v : Number(v);
  if (Number.isFinite(n)) {
    const d = new Date(n);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

function formatSlotLabel(v) {
  const d = toValidDate(v);
  return d
    ? d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    : '—';
}

function normalizeTimetableEvents(raw) {
  const merged = mergeEmptyDays(raw);
  const out = {};
  Object.keys(EMPTY_TIMETABLE_DAYS).forEach((day) => {
    const list = Array.isArray(merged[day]) ? merged[day] : [];
    out[day] = list
      .map((ev, idx) => {
        if (!ev || typeof ev !== 'object') return null;
        const start = toValidDate(ev.startTime);
        const end = toValidDate(ev.endTime);
        if (!start || !end) return null;
        return {
          ...ev,
          id: ev.id != null ? ev.id : `${day}-${idx}`,
          name: ev.name != null ? String(ev.name) : '—',
          startTime: start,
          endTime: end,
        };
      })
      .filter(Boolean);
  });
  return out;
}

/** Parse HTML time input (HH:mm) — avoids Safari issues with `new Date("2018-02-23 09:00")`. */
function parseTimeMs(timeStr) {
  const t = String(timeStr || '').trim();
  if (!t) return NaN;
  const part = t.length === 5 ? `${t}:00` : t;
  const d = new Date(`2000-01-01T${part}`);
  return d.getTime();
}

/** DB may store timetable as { monday: [] } or [{ monday: [] }, …]. */
function timetableAsWeekBlocks(tt) {
  if (!tt) return [];
  if (Array.isArray(tt)) {
    return tt.filter((w) => w && typeof w === 'object').map((w) => mergeEmptyDays(w));
  }
  if (typeof tt === 'object') {
    return [mergeEmptyDays(tt)];
  }
  return [];
}

function timetableWeekArrayForMutation(tt) {
  const blocks = timetableAsWeekBlocks(tt);
  return blocks.length > 0 ? blocks : [{ ...EMPTY_TIMETABLE_DAYS }];
}

export default function Write (){


    const componentRef = useRef()

     const dispatch = useDispatch()

     const admin = useSelector((state) => state.admin)
     const schooldetails_ = useSelector((state) => state.schooldetails)
     const schooldata= async () => {
         await axios.post("https://servermain.sisrevolution.com/api/schools/getschooldata/",
             {
                 schoolID:admin.schoolID
 
             }).then(res => {
 
                 if (res.status === 200) {
 
                     dispatch(schooldetails({
 
                         data: res.data
 
                     }))
 
 
                 }
 
             })
 
     }
 
 
 
   const gettingdata = async () => {
        await axios.post("https://servermain.sisrevolution.com/api/class/getclassdata/",
            {
                schoolID:admin.schoolID
            }).then(res => {
                if (res.status === 200) {
                    dispatch(getdata_({
                        data: res.data
                    }))
                }
            })
    }

    
    const classer = useSelector((state) => state.class)
     var main= admin.class_===undefined? classer:classer.filter(bug=>bug.classname===admin.positiondescription_)
    //  var Class_ = admin.class_===undefined? classer:classer.filter(bug=>bug.classname===admin.positiondescription_)

    // var main = useSelector((state) => state.class)
    var rows = main

    const [classname, setclassname] = React.useState("none")
    const [selectedday, setselectedday] = React.useState("none")
    const [changesubject, setchangesubject] = React.useState("none")
    const [openview, setOpenview] = React.useState(!true);
    const [chosen, setchosen] = React.useState("");
    const [loadpage, setloadpage] = React.useState(true);
    const [maintable, setmaintable] = React.useState({});


    useEffect(()=>{

         gettingdata()
         setloadpage(!true)



},[loadpage])
    
    

    useEffect(()=>{
        if (!Array.isArray(chosen) || chosen.length === 0 || classname === 'none') {
            setmaintable({ ...EMPTY_TIMETABLE_DAYS });
            return;
        }
        const classRow = rows.find((bug) => bug.classname === chosen[0].classname);
        const blocks = timetableAsWeekBlocks(classRow?.timetable);
        if (blocks.length === 0) {
            setmaintable({ ...EMPTY_TIMETABLE_DAYS });
            return;
        }
        setmaintable(mergeEmptyDays(blocks[0]));
    },[chosen, classname, rows])
    
    
      const addtable = () => {

         //setloading(true)

        var starttime_ = document.getElementById("starttime").value
        var endtime_ = document.getElementById("endtime").value
        const startMs = parseTimeMs(starttime_)
        const endMs = parseTimeMs(endtime_)
        if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) {
            window.alert('Choose valid start and end times (end after start).')
            return
        }
        const classRow = rows.find((bug) => bug.classname === chosen[0].classname)
        if (!classRow) return

        var data =   {
        
        name: changesubject,
        type: changesubject!=="Break"? "custom":"error",
        startTime: startMs,
        endTime: endMs,
      }

        const tablemain = timetableWeekArrayForMutation(classRow.timetable)
        const week0 = mergeEmptyDays(tablemain[0])
        const dayKey = selectedday.toLowerCase()
        const prevDay = Array.isArray(week0[dayKey]) ? week0[dayKey] : []
        const updatedWeek = { ...week0, [dayKey]: [...prevDay, data] }
        var newday = [updatedWeek, ...tablemain.slice(1)]

const doer = async () => {
            await axios.post("https://servermain.sisrevolution.com/api/class/addtimetable/",
                {
                   _id:chosen[0]._id,
                   data:newday,
                   schoolID:admin.schoolID
                }).then(res => {

                    if (res.status === 200) {

                         dispatch(getdata_({
                        data: res.data
                    }))
                        //setloading(!true)
                        //handleClosedelete()
                        //handleClicksnack()
                        //setmessage("Data has been deleted")
                        //setstated("success")

                    } else {

                        //setloading(!true)
                        //handleClosedelete()
                        //handleClicksnack()
                        //setmessage("Error deleting data")
                        //setstated("error")
                    }

                })

        }

        try{
            doer()
        }catch(err){
                        
                        
        }

    }

      
      const deletetable = (data, day_) => {

         //setloading(true)

            const classRow = rows.find((bug) => bug.classname === chosen[0].classname)
            if (!classRow) return

            const tablemain = timetableWeekArrayForMutation(classRow.timetable)
            const week0 = mergeEmptyDays(tablemain[0])
            const dayArr = Array.isArray(week0[day_]) ? week0[day_] : []
            var new2 = dayArr.filter(
              (bug) => !(bug.endTime === data.endTime && bug.startTime === data.startTime)
            )
            var newer = { ...week0, [day_]: new2 }
            var main_ = [newer, ...tablemain.slice(1)]

     
const doer = async () => {
            await axios.post("https://servermain.sisrevolution.com/api/class/addtimetable/",
                {
                   _id:chosen[0]._id,
                   data:main_,
                   schoolID:admin.schoolID
                }).then(res => {

                    if (res.status === 200) {
                 dispatch(getdata_({
                        data: res.data
                    }))
                        
                        //setloading(!true)
                        //handleClosedelete()
                        //handleClicksnack()
                        //setmessage("Data has been deleted")
                        //setstated("success")

                    } else {

                        //setloading(!true)
                        //handleClosedelete()
                        //handleClicksnack()
                        //setmessage("Error deleting data")
                        //setstated("error")
                    }

                })

        }
try{
            doer()
} catch{
    
    // setmessage("Error deleting data")
    // setstated("error")
}
    }

    
    
    const clearsubject = ()=>{

        var subjects = rows.subjects
        console.log(subjects)

    }

const handleChangeclass = (e) =>{

setclassname(e.target.value)
var newer = rows.filter(bug=> bug.classname === e.target.value)
setchosen(newer)
}

const handleChangeday = (e) =>{
setselectedday(e.target.value)
}

const handleChangesubject = (e) =>{
setchangesubject(e.target.value)
}

const handleClickOpenview = () => {
    setOpenview(true);
};

const handleCloseview = () => {
  setOpenview(false);
};

    const dialogWeekBlocks =
      classname !== 'none' && Array.isArray(chosen) && chosen.length > 0
        ? timetableAsWeekBlocks(rows.find((r) => r.classname === classname)?.timetable)
        : [];

    return(

<div style={{backgroundColor:"white", borderRadius:"5px"}}>
<br/>
<Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                TIMETABLE
            </Typography>
        
<FormControl style={{ margin: 20, textAlign:"left", backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            align="left"
                            value={classname}
                            style={{ minWidth: 150, padding: 0}}
                            onChange={handleChangeclass}
                            size="small"
                        >
                         <MenuItem value="none">select class</MenuItem>

                        {rows.map((list,index)=>
                         <MenuItem value={list.classname} >{list.classname}</MenuItem>
                        
                        )}
                           
                        </Select>
                    </FormControl>
{classname!=="none"?
<span>
<Button onClick={handleClickOpenview} style={{backgroundColor:" #e0eff9" , color:"#1976d2", marginTop:20}}>Add / Edit Time Table </Button>

<ReactToPrint
           trigger={()=><Button style={{marginTop:20, marginLeft:10, backgroundColor:" #e0eff9" , color:"#1976d2"}}>Print Timetable</Button>}
            content ={()=>componentRef.current}
            />
</span>
:
""
}
<Dialog  maxWidth="md" onClose={handleCloseview} aria-labelledby="customized-dialog-title" open={openview}>
                <DialogTitle id="customized-dialog-title" onClose={handleCloseview} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Set Time Table
                    <IconButton style={{float:"right", color:"white"}} autoFocus onClick={handleCloseview} color="primary">
                        <Close/>
                    </IconButton>
                </DialogTitle>
               
                <DialogContent dividers>

                <FormControl style={{ margin: 10, textAlign:"left"}}>
               <small>Day</small>
                        <Select
                            labelId="input-with-icon-adornment"
                            id="selectedday"
                            align="left"
                            value={selectedday}
                            style={{ minWidth: 150, padding: 0}}
                            onChange={(e)=>handleChangeday(e)}
                            className="signup"
                            size="small"
                        >
                            <MenuItem value="none"><em>Choose Day</em></MenuItem>
                            <MenuItem value="Monday">Monday</MenuItem>
                            <MenuItem value="Tuesday">Tuesday</MenuItem>
                            <MenuItem value="Wednesday">Wednesday</MenuItem>
                            <MenuItem value="Thursday">Thursday</MenuItem>
                            <MenuItem value="Friday">Friday</MenuItem>
                            
                        </Select>
                    </FormControl>
 <FormControl style={{ margin: 10, textAlign:"left"}}>
 <small>Subject</small>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            align="left"
                            value={changesubject}
                            style={{ minWidth: 150, padding: 0}}
                            onChange={handleChangesubject}
                            className="signup"

                            size="small"
                        >
                    
                        {chosen !== "" && classname!=="none"? 
                        chosen[0].subjects[0].map((list, index)=>

                            <MenuItem value={list.subject}> {list.subject} </MenuItem>
                        ):""
                        }
                        <MenuItem value="Break">Break</MenuItem>


                        </Select>
                    </FormControl>

                <br/>

                <FormControl variant="standard" style={{ margin: 10 }}>
                <small>Start Time</small>
                    <TextField
                        id="starttime"
                        type="time"
                        className="signup"
                        variant="outlined"
                        size="small"



                    />
                    </FormControl>
                
                <FormControl variant="standard" style={{ margin: 10 }}>
                <small>End Time</small>
                    <TextField
                        id="endtime"
                        type="time"
                        className="signup"
                        variant="outlined"
                        size="small"



                    />
                    </FormControl>
                
                <Divider/>

                <TableContainer component={Paper}>
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
                      <TableCell style={{fontWeight:"bolder"}} >Day</TableCell>
                      <TableCell style={{fontWeight:"bolder"}} align="left">Subject</TableCell>
                      <TableCell style={{fontWeight:"bolder"}} align="left">Sarting time</TableCell>
                      <TableCell style={{fontWeight:"bolder"}} align="left">Ending time</TableCell>
                      <TableCell style={{fontWeight:"bolder"}} align="left">Action </TableCell>

          </TableRow>
        </TableHead>
        {dialogWeekBlocks.map((rower, bi) => (
          <TableBody key={`timetable-week-${bi}`}>
            {Array.isArray(rower.monday) &&
              rower.monday.map((row, ri) => (
                <TableRow
                  key={`m-${bi}-${ri}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">Monday</TableCell>
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.startTime)}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.endTime)}</TableCell>
                  <TableCell align="left">
                    {' '}
                    <Button onClick={() => deletetable(row, 'monday')}>delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            {Array.isArray(rower.tuesday) &&
              rower.tuesday.map((row, ri) => (
                <TableRow
                  key={`t-${bi}-${ri}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">Tuesday</TableCell>
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.startTime)}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.endTime)}</TableCell>
                  <TableCell align="left">
                    {' '}
                    <Button onClick={() => deletetable(row, 'tuesday')}>delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            {Array.isArray(rower.wednesday) &&
              rower.wednesday.map((row, ri) => (
                <TableRow
                  key={`w-${bi}-${ri}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">Wednesday</TableCell>
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.startTime)}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.endTime)}</TableCell>
                  <TableCell align="left">
                    {' '}
                    <Button onClick={() => deletetable(row, 'wednesday')}>delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            {Array.isArray(rower.thursday) &&
              rower.thursday.map((row, ri) => (
                <TableRow
                  key={`th-${bi}-${ri}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">Thursday</TableCell>
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.startTime)}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.endTime)}</TableCell>
                  <TableCell align="left">
                    {' '}
                    <Button onClick={() => deletetable(row, 'thursday')}>delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            {Array.isArray(rower.friday) &&
              rower.friday.map((row, ri) => (
                <TableRow
                  key={`f-${bi}-${ri}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="left">Friday</TableCell>
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.startTime)}</TableCell>
                  <TableCell align="left">{formatSlotLabel(row.endTime)}</TableCell>
                  <TableCell align="left">
                    {' '}
                    <Button onClick={() => deletetable(row, 'friday')}>delete</Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        ))}
      
      </Table>
    </TableContainer>

                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>addtable()} color="primary">
                        add timetable
                    </Button>
                    
                    <Button autoFocus onClick={handleCloseview} color="primary">
                        close
                    </Button>
                </DialogActions>
            </Dialog>



<div  ref={componentRef} >
<p align="center"><b>{classname.toUpperCase()}</b></p>
{Array.isArray(chosen) && chosen.length > 0 ?
<Timetable 
   bodyAttributes={{
    className: 'styles-module__my_custom_day_body__JnVZR'
  }}


  events={normalizeTimetableEvents(maintable)}

  headerAttributes={{
    className: 'styles-module__my_custom_day_header__ah3Tn'
  }}
//   renderDayHeader={function noRefCheck(){}}
//   renderEvent={function noRefCheck(){}}
//   renderHour={function noRefCheck(){}}
  style={{
    height: '100%',
    color:"red"
  }}
  timeLabel=""


/>:<Timetable
 headerAttributes={{
    className: 'tablehead'
  }}
    bodyAttributes={{
      
    className: 'tablebody'
  }}
  

events={EMPTY_TIMETABLE_DAYS}
  />}

</div>

</div>

    )
}